// extracted by mini-css-extract-plugin
export default {"info":"info__q7aEg","icon":"icon__a48Bp","content":"content__iLdDA","text":"text__jAqmD"};